import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BandejaInscripcionesComponent } from '../listado-inscripciones/bandeja-inscripciones/bandeja-inscripciones.component';
import { Solicitud } from '../../../../../interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import {
    APP_CONFIG_OFERTAS,
    IAppOfertas,
} from '../../../../../app.config/app.config-ofertas';
import { SolicitudesService } from '../../../../../services/ofertas-laborales/solicitudes.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SignoSede } from 'src/app/interfaces/interface-bakend/entidades/signo-sede.interface';
import { SignoSedeService } from 'src/app/services/entidades/signo-sedes.service';
import { Router } from '@angular/router';
import { Actividad } from '@interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import { ActividadesService } from '@services/ofertas-laborales/actividades.service';
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-listado-inscripciones',
    templateUrl: './listado-inscripciones.component.html',
    styleUrls: ['./listado-inscripciones.component.scss'],
})
export class ListadoInscripcionesComponent implements OnInit, OnDestroy {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    displayedColumns: string[] = [
        'nro_solicitud',
        'fechaEstado',
        'trámite',
        'tipo',
        'identificacion',
        'estado',
        'progreso',
        'id',
    ];

    dataSource = new MatTableDataSource<Solicitud>();
    solicitudes: Solicitud[] = [];
    flagLoaded = true;
    activarButton = true;
    fecha: any;

    newState: Subscription;
    private newStateSubscription: Subscription;
    sedesByUsuario: SignoSede[] = [];
    selectedEstados: number[] = [];
    estadosInscripcion: { number: number; name: string; detail?: string }[] = [];
    actividades: Actividad[] = [];
    idActividadSeleccionada: string;
    flagSolicitudesCargadas = false;

    fechaDesde: Date;
    fechaHasta: Date;

    loading: boolean = false;

    // Actividad de inscripción General
    private readonly idsInscripciones = [
        '68c86b61e6c4fc16024be451',
    ];

    private readonly FECHA_CORTE_FILTRO = new Date('2026-08-04T00:00:00.000Z');

    constructor(
        @Inject(APP_CONFIG_OFERTAS) public iAppOfertas: IAppOfertas,
        private router: Router,
        private solicitudesService: SolicitudesService,
        public dialog: MatDialog,
        private authService: AuthService,
        private signoSedeService: SignoSedeService,
        private actividadesService: ActividadesService,
        private snackBar: MatSnackBar
    ) {
        // Solo los estados de inscripción
        this.estadosInscripcion = this.iAppOfertas.selectEstados.filter(
            (e) => [14, 15, 16].includes(e.number)
        );

        this.newStateSubscription = this.solicitudesService
            .getsetNewStater()
            .subscribe((resp) => {
                const solicitudIndex = this.dataSource.filteredData.findIndex(
                    (solicitud) => solicitud._id === resp?.state?._id
                );

                if (solicitudIndex !== -1) {
                    this.dataSource.filteredData[
                        solicitudIndex
                    ].lastState_numberState =
                        resp.state?.lastState?.numberState;

                    this.dataSource = new MatTableDataSource(
                        this.dataSource.filteredData
                    );

                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                }

                this.newState = resp;
            });
    }

    establecerFechadeBusqueda(): void {
        const ahora = new Date();
        this.fechaDesde = new Date(ahora.getFullYear(), ahora.getMonth(), 1);
        this.fechaHasta = new Date(
            ahora.getFullYear(),
            ahora.getMonth() + 1,
            0
        );
    }

    async ngOnInit(): Promise<void> {
        this.establecerFechadeBusqueda();
        await this.obtenerSedesUsuario();
        await this.getActividadesInscripcion();
    }

    ngOnDestroy(): void {
        if (this.newStateSubscription) {
            this.newStateSubscription.unsubscribe();
        }
    }

    formatDate(date: Date): string {
        return date.toISOString().split('T')[0];
    }

    // Obtiene las sedes del usuario (uso interno, sin UI)
    async obtenerSedesUsuario(): Promise<void> {
        const sedes = await this.signoSedeService.getSedes();
        const usuario = await this.authService.getUserLogon();
        if (sedes) {
            this.sedesByUsuario = sedes.filter((sede: any) =>
                usuario.signoSedes.includes(sede?._id)
            );
        }
    }

    // Carga únicamente las tres actividades de inscripción
    async getActividadesInscripcion() {
        try {
            const actividadesPromises = this.idsInscripciones.map((id) =>
                this.actividadesService.getActividadesFindOne(id)
            );
            this.actividades = await Promise.all(actividadesPromises);
            if (this.actividades?.length) {
                this.idActividadSeleccionada = this.actividades[0]._id;
            }
        } catch (error) {
            console.error('Error al cargar actividades de inscripción:', error);
            this.snackBar.open('Error al cargar actividades de inscripción', 'Cerrar', {
                duration: 3000,
            });
        }
    }

    // Búsqueda principal por fechas
    async buscarPorFechas() {
        if (this.fechaDesde && this.fechaHasta) {
            this.flagLoaded = false;
            this.fecha = {
                fechaDesde: this.formatDate(this.fechaDesde),
                fechaHasta: this.formatDate(this.fechaHasta),
            };
            this.flagSolicitudesCargadas = false;

            const sedesParams = {
                signoSedes: this.sedesByUsuario.map((s) => s._id),
            };
            await this.cargarInicialdeSolicitudes(sedesParams, this.fecha);
        } else {
            this.snackBar.open('Por favor, seleccione ambas fechas', 'Cerrar', {
                duration: 3000,
            });
        }
    }

    async cargarSolicitudesPorEstado(selectedEstados: number[]) {
        if (selectedEstados.length > 0) {
            this.selectedEstados = selectedEstados;
            await this.applyFilters();
        }
    }

    openDialogModalSolicitud(): void {
        const dialogRef = this.dialog.open(BandejaInscripcionesComponent, {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            panelClass: 'full-screen-dialog',
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe();
    }

    async applyFilters(): Promise<Solicitud[]> {
        let filteredSolicitudes = this.solicitudes;

        if (this.selectedEstados.length > 0) {
            filteredSolicitudes = filteredSolicitudes.filter((solicitud) =>
                this.selectedEstados.includes(solicitud.lastState_numberState)
            );
        }

        const data = await this.formatDataTable(
            filteredSolicitudes,
            this.idActividadSeleccionada
        );

        this.dataSource = new MatTableDataSource<Solicitud>(data);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.flagLoaded = true;
        return data;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    reloadCurrentRoute() {
        this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
                this.router.navigate(['autorizaciones-listado']);
            });
    }

    async formatDataTable(
        solicitudes: Solicitud[],
        idActividadSeleccionada: string
    ): Promise<Solicitud[]> {
        return solicitudes.filter(
            (s) => s.actividadId === idActividadSeleccionada
        );
    }

    getTipoAfiliacion(solicitud: any): string {
        const tipo = solicitud?.inscripcion?.contenido?.tipoAfiliacion;
        return tipo === 'mutual' ? 'Mutual' : tipo === 'sindicato' ? 'Sindicato' : '';
    }

    getStateName(stateNumber: number): string {
        const estado = this.iAppOfertas.selectEstados.find(e => e.number === stateNumber);
        return estado ? estado.name : 'Desconocido';
    }

    getColor(stateNumber: number): string {
        switch (stateNumber) {
            case 4:
                return '#28a745';
            case 3:
                return 'rgb(173, 216, 230)';
            case 2:
                return '#ffc107';
            case 1:
                return '#6c757d';
            case 5:
                return '#dc3545';
            default:
                return '';
        }
    }

    private debeIncluirSolicitud(solicitud: any, numberState: number): boolean {
        const createdAt = solicitud?.createdAt
            ? new Date(solicitud.createdAt)
            : null;

        if (createdAt && createdAt >= this.FECHA_CORTE_FILTRO) {
            return numberState !== 0;
        }

        return numberState !== 0 && numberState !== 1;
    }

    async prepararSolicitudesPorTab(solds: Solicitud[]): Promise<Solicitud[]> {
        return await this.formatDataTable(
            solds,
            this.idActividadSeleccionada
        ).then((data: Solicitud[]) => {
            this.dataSource = new MatTableDataSource<Solicitud>(data);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.flagLoaded = true;
            return data;
        });
    }

    async cargarInicialdeSolicitudes(
        sedeParams: { signoSedes: string[] },
        fecha: any
    ): Promise<Solicitud[]> {
        try {
            this.selectedEstados = this.iAppOfertas.selectEstados.map(
                (e) => e.number
            );

            const allSolicitudes =
                await this.solicitudesService.getAllSolicitudesInscripciones(sedeParams, fecha);

            this.solicitudes = allSolicitudes.filter((solicitud) => {
                const numberState =
                    (solicitud as any)?.lastState_numberState ??
                    solicitud?.lastState?.numberState ??
                    -1;
                return this.debeIncluirSolicitud(solicitud, numberState);
            });

            this.flagSolicitudesCargadas = true;

            if (this.actividades?.length) {
                this.idActividadSeleccionada = this.actividades[0]._id;
            } else {
                console.warn('No hay actividades de inscripción cargadas.');
                this.idActividadSeleccionada = undefined as any;
            }

            return await this.prepararSolicitudesPorTab(this.solicitudes);
        } catch (error) {
            console.error('Error al cargar solicitudes:', error);
            throw error;
        }
    }

    async verSolicitud(solicitud: Solicitud) {
        this.loading = true;
        try {
            const sol = await this.solicitudesService.getSolicitudById(
                solicitud._id
            );
            this.solicitudesService.setSolicitudSeleccionada(sol);
            await this.updateSolicitudLeido(sol);
            solicitud.leido = true;
            this.openDialogModalSolicitud();
        } catch (error) {
            console.error('Error al ver la solicitud:', error);
        } finally {
            this.loading = false;
        }
    }

    async updateSolicitudLeido(sol: Solicitud) {
        const solicitud: any = {
            _id: sol._id,
            leido: true,
            titular: sol.titular,
            usuario: sol.usuario,
            pais: sol.pais._id,
            actividad: sol.actividad._id,
        };

        await this.solicitudesService.updateSolicitudLeido(sol._id, solicitud);
    }

    async exportarSolicitudes(): Promise<void> {
        if (!this.fechaDesde || !this.fechaHasta) {
            this.snackBar.open(
                'Por favor, seleccione ambas fechas para exportar',
                'Cerrar',
                { duration: 3000 }
            );
            return;
        }

        this.loading = true;

        try {
            const fechaParams = {
                fechaDesde: this.formatDate(this.fechaDesde),
                fechaHasta: this.formatDate(this.fechaHasta),
            };

            const sedesParams: any = {
                signoSedes: this.sedesByUsuario.map((s) => s._id),
            };

            const allSolicitudes =
                await this.solicitudesService.getSolicitudesBySedeExtendido(
                    sedesParams,
                    fechaParams
                );

            const allSolicitudesConCampos = allSolicitudes as any[];

            const solicitudesFiltradas = allSolicitudesConCampos.filter(
                (solicitud) => {
                    const numberState = solicitud?.lastState_numberState ?? -1;
                    return this.debeIncluirSolicitud(solicitud, numberState);
                }
            );

            if (!solicitudesFiltradas || solicitudesFiltradas.length === 0) {
                this.snackBar.open(
                    'No hay solicitudes para exportar en el rango de fechas seleccionado',
                    'Cerrar',
                    { duration: 3000 }
                );
                this.loading = false;
                return;
            }

            const datosExcel =
                this.prepararDatosParaExcel(solicitudesFiltradas);
            this.generarExcel(datosExcel);

            this.snackBar.open(
                `Exportadas ${solicitudesFiltradas.length} solicitudes`,
                'Cerrar',
                { duration: 3000 }
            );
        } catch (error) {
            console.error('Error al exportar solicitudes:', error);
            this.snackBar.open('Error al exportar las solicitudes', 'Cerrar', {
                duration: 3000,
            });
        } finally {
            this.loading = false;
        }
    }

    prepararDatosParaExcel(solicitudes: any[]): any[] {
        return solicitudes.map((solicitud) => {
            const fechaFormateada = this.formatearFechaExcel(
                solicitud.createdAt
            );
            const fechaUltimaModFormateada = this.formatearFechaExcel(
                solicitud.dateLastState
            );

            return {
                'Número de Solicitud': solicitud._nro,
                DNI: solicitud.usuario_identificacion || 'N/A',
                Paciente: solicitud.beneficiario || 'N/A',
                Fecha: fechaFormateada,
                Procedimiento: solicitud.actividad_nombre || 'N/A',
                Solicitante: solicitud.solicitante || 'N/A',
                Sede: solicitud.signoSedeNombre || 'N/A',
                Administrador: solicitud.lastState_userName || 'N/A',
                Estado: `${solicitud.lastState_state}`,
                Observaciones: solicitud.lastState_observaciones || 'N/A',
                'Estados Historicos': solicitud.historicoEstados || 'N/A',
                'Fecha del Ultimo Estado': fechaUltimaModFormateada || 'N/A',
            };
        });
    }

    formatearFechaExcel(fechaISO: string | Date): string {
        try {
            const fechaString =
                typeof fechaISO === 'string'
                    ? fechaISO
                    : fechaISO instanceof Date
                    ? fechaISO.toISOString()
                    : '';

            const fecha = new Date(fechaString);
            const dia = fecha.getDate().toString().padStart(2, '0');
            const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
            const anio = fecha.getFullYear();
            const horas = fecha.getHours().toString().padStart(2, '0');
            const minutos = fecha.getMinutes().toString().padStart(2, '0');

            return `${dia}/${mes}/${anio} ${horas}:${minutos}`;
        } catch (error) {
            console.error('Error formateando fecha:', error);
            return 'Fecha inválida';
        }
    }

    generarExcel(datos: any[]): void {
        const worksheet = XLSX.utils.json_to_sheet(datos);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Solicitudes');

        const wscols = [
            { wch: 20 },
            { wch: 12 },
            { wch: 25 },
            { wch: 20 },
            { wch: 35 },
            { wch: 30 },
            { wch: 20 },
            { wch: 30 },
            { wch: 18 },
            { wch: 50 },
            { wch: 50 },
            { wch: 20 },
        ];
        worksheet['!cols'] = wscols;

        const fechaDesdeStr = this.formatDate(this.fechaDesde);
        const fechaHastaStr = this.formatDate(this.fechaHasta);
        const nombreArchivo = `Inscripciones_${fechaDesdeStr}_a_${fechaHastaStr}.xlsx`;

        XLSX.writeFile(workbook, nombreArchivo, { compression: true });
    }
}